// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".count-input[data-v-b8e8508e]{font-size:.75rem;width:5rem}", "",{"version":3,"sources":["webpack://./resources/js/tenant/Components/View/POS/Cart/CountControl.vue"],"names":[],"mappings":"AACA,8BACI,gBAAA,CACA,UAAJ","sourcesContent":["\n.count-input\n    font-size: .75rem\n    width: 5rem\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
